import React, { lazy } from 'react';
import { ExternalLink } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WavyDivider } from '../components/WavyDivider';
import { useSeo } from '../lib/useSeo';
export function Podcasts() {
  useSeo({
    title: 'Podcasts',
    description: "Listen to Milangela's podcasts on Anchor. Discover inspiring stories of courage, strength, and overcoming life's hurdles.",
    path: '/podcasts',
    image: 'https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&q=80&w=2000'
  });
  return <div className="min-h-screen flex flex-col bg-cream" data-id="element-409">
      <Header data-id="element-410" />

      <section className="relative h-[60vh] min-h-[440px] flex items-center justify-center overflow-hidden" data-id="element-411">
        <div className="absolute inset-0 z-0" data-id="element-412">
          <img src="https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&q=80&w=2000" alt="Sunlit meadow with dandelions" className="w-full h-full object-cover" data-id="element-413" />
          <div className="absolute inset-0 bg-white/55" data-id="element-414"></div>
        </div>
        <div className="relative z-10 text-center px-6 mt-16" data-id="element-415">
          <h1 className="font-serif text-charcoal drop-shadow-sm" data-id="element-416">
            <span className="block text-6xl md:text-7xl mb-2" data-id="element-417">Podcasts</span>
            <span className="block text-xl md:text-2xl font-serif text-sage-700" data-id="element-418">
              made by Milangela's Soul Garden
            </span>
          </h1>
        </div>
        <div className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none" data-id="element-419">
          <WavyDivider fill="#EAE3A1" data-id="element-420" />
        </div>
      </section>

      <section className="bg-[#EAE3A1] py-20 px-6" data-id="element-421">
        <div className="max-w-2xl mx-auto text-center mb-16" data-id="element-422">
          <a href="https://anchor.fm/" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-3 border border-charcoal text-charcoal text-sm tracking-widest hover:bg-charcoal hover:text-[#EAE3A1] transition-colors" data-id="element-423">
            Listen to Milangela's podcasts on Anchor
          </a>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-424">
          <p className="text-charcoal-50 font-light leading-relaxed text-sm md:text-justify" data-id="element-425">
            … a wide-open door that ultimately leads to new opportunities. The
            organic interplay of strolling in nature, pondering spirituality,
            discovering your giftedness, cultivating creativity, and keeping a
            positive mindset.
            <br data-id="element-426" />
            <br data-id="element-427" />
            Sometimes the burden of life is just too heavy to carry and people
            might feel overwhelmed and lost in the maze of all that is
            available, when in fact the best remedies and help are hidden inside
            of us.
            <br data-id="element-428" />
            <br data-id="element-429" />
            If the sentence "I could appreciate some advice" is yours, you are
            in the right place. So many of us have experienced the bad and the
            dark and managed to re-invent our new reality!
          </p>
          <p className="text-charcoal-50 font-light leading-relaxed text-sm md:text-justify" data-id="element-430">
            And if we made it, so can you! But it takes your willpower and
            determination! Without either we are powerless!
            <br data-id="element-431" />
            <br data-id="element-432" />
            I am committed to inspiring people, embracing the future and new
            opportunities, rather than contemplating the sad, grim events of the
            past. My guests narrate the hardship they had experienced in a
            relatable way, to encourage you to follow in their footsteps and
            perceive your life path anew.
            <br data-id="element-433" />
            <br data-id="element-434" />I feel humbled and honored to be able to hear about the
            unbelievable courage, strength, perseverance, and willpower
            experienced by my guests.
          </p>
          <p className="text-charcoal-50 font-light leading-relaxed text-sm md:text-justify" data-id="element-435">
            Every one of them opens yet another life chapter. They enrich me.
            Becoming part of this community, many of you who need that
            encouragement and support will hopefully rethink your decisions,
            leave your past behind, and move forward.
            <br data-id="element-436" />
            <br data-id="element-437" />
            To stumble on a hurdle is something most of us have done. It's only
            human. But to be able to find a way around it, with a positive
            attitude, is the privilege of the brave and the mindful.
            <br data-id="element-438" />
            <br data-id="element-439" />
            So make sure you ARE part of this tribe!
          </p>
        </div>
      </section>

      {/* QUOTE SECTION */}
      <section className="relative bg-[#EAE3A1] py-24 px-6 overflow-hidden" data-id="element-440">
        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-441">
          <div className="text-6xl font-serif text-sage-600 leading-none mb-4" data-id="element-442">
            "
          </div>
          <p className="font-serif text-3xl md:text-4xl text-charcoal italic leading-snug mb-5" data-id="element-443">
            It is not the hearing that improves life, but the listening.
          </p>
          <p className="text-charcoal-50 text-sm tracking-widest uppercase" data-id="element-444">
            — Mihaly Csikszentmihalyi
          </p>
        </div>
      </section>
      <div className="relative bg-[#EAE3A1] pointer-events-none" data-id="element-445">
        <WavyDivider fill="#3A3A38" data-id="element-446" />
      </div>

      <Footer data-id="element-447" />
    </div>;
}